import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { CanNavigateInStepperService } from '../../../shared/services/can-navigate-in-stepper.service';

@Injectable({
	providedIn: 'root'
})
export class EformDynamicListService {

	public lotName: BehaviorSubject<string[]> = new BehaviorSubject([]);
	public form = null;
	private organizationName: BehaviorSubject<string[]> = new BehaviorSubject([]);
	private tendererName: BehaviorSubject<string[]> = new BehaviorSubject([]);
	private offerName: BehaviorSubject<string[]> = new BehaviorSubject([]);

	constructor(private canNavigateInStepperService: CanNavigateInStepperService) {
	}

	setOrganizationName(form: FormGroup, orgs: any[]) {

		//Initialise les noms des organisations
		let noticeType: string;
		orgs.sort((a, b) => a.id.localeCompare(b.id));
		if (form?.value) {
			noticeType = Object.keys(form?.value)[0];
		}
		if (noticeType) {
			let orgsName: string[] = [];
			let orgFromFormUsed: boolean = false;
			for (let i = 0; i < orgs?.length; i++) {
				if (orgs[i]?.id != form?.get(noticeType)['controls']?.ublextensions?.controls.ublextension?.controls[0]?.controls.extensioncontent?.controls.eformsextension?.controls.organizations?.controls.organization?.controls[0]?.controls.company?.controls.partyidentification?.value.id.val || this.canNavigateInStepperService.eformCreatingChange) {
					orgsName.push(orgs[i]?.name);
				} else {
					orgFromFormUsed = true;
					if (form?.get(noticeType)['controls']?.ublextensions?.controls.ublextension?.controls[0]?.controls.extensioncontent?.controls.eformsextension?.controls.organizations?.controls.organization?.controls[0]?.controls.company?.partyname?.controls[0]?.value.name.val === null && orgs[i]?.name) {
						orgsName.push(orgs[i]?.name);
					} else {
						orgsName.push(form?.get(noticeType)['controls']?.ublextensions?.controls.ublextension?.controls[0]?.controls.extensioncontent?.controls.eformsextension?.controls.organizations?.controls.organization?.controls[0]?.controls.company?.controls.partyname?.controls[0]?.value.name.val);
					}
				}
			}
			if (!orgFromFormUsed && !this.canNavigateInStepperService.eformCreatingChange) {
				orgsName.push(form?.get(noticeType)['controls']?.ublextensions?.controls.ublextension?.controls[0]?.controls.extensioncontent?.controls.eformsextension?.controls.organizations?.controls.organization?.controls[0]?.controls.company?.controls.partyname?.controls[0]?.value.name.val);
			}
			this.organizationName.next(orgsName);
		} else {
			let orgsName: string[] = [];
			for (let i = 0; i < orgs?.length; i++) {
				orgsName.push(orgs[i]?.name);
			}
			this.organizationName.next(orgsName);
		}
	}

	getOrganizationName(): BehaviorSubject<string[]> {
		return this.organizationName;
	}

	setTendererName(form: FormGroup, tenderers: any[]) {

		//Initialise les noms des sous missionaire
		let noticeType: string;
		tenderers.sort((a, b) => a.id.localeCompare(b.id));
		if (form?.value) {
			noticeType = Object.keys(form?.value)[0];
		}
		if (noticeType) {
			let tenderersName: string[] = [];
			let tendererFromFormUsed: boolean = false;
			for (let i = 0; i < tenderers?.length; i++) {
				if (tenderers[i]?.id != form?.get(noticeType)['controls']?.ublextensions?.controls.ublextension?.controls[0]?.controls.extensioncontent?.controls.eformsextension?.controls.noticeresult?.controls.tenderingparty?.controls[0]?.value.id.val || this.canNavigateInStepperService.eformCreatingChange) {
					tenderersName.push(tenderers[i]?.name);
				} else {
					tendererFromFormUsed = true;
					if (form?.get(noticeType)['controls']?.ublextensions?.controls.ublextension?.controls[0]?.controls.extensioncontent?.controls.eformsextension?.controls.noticeresult?.controls.tenderingparty?.controls[0]?.value.name?.[0].val === null && tenderers[i]?.name) {
						tenderersName.push(tenderers[i]?.name);
					} else {
						tenderersName.push(form?.get(noticeType)['controls']?.ublextensions?.controls.ublextension?.controls[0]?.controls.extensioncontent?.controls.eformsextension?.controls.noticeresult?.controls.tenderingparty?.controls[0]?.value.name?.[0].val);
					}
				}
			}
			if (!tendererFromFormUsed && !this.canNavigateInStepperService.eformCreatingChange) {
				tenderersName.push(form?.get(noticeType)['controls']?.ublextensions?.controls.ublextension?.controls[0]?.controls.extensioncontent?.controls.eformsextension?.controls.noticeresult?.controls.tenderingparty?.controls[0]?.value.name?.[0].val);
			}
			this.tendererName.next(tenderersName);
		} else {
			let tenderersName: string[] = [];
			for (let i = 0; i < tenderers?.length; i++) {
				tenderersName.push(tenderers[i]?.name);
			}
			this.tendererName.next(tenderersName);
		}
	}

	getTendererName(): BehaviorSubject<string[]> {
		return this.tendererName;
	}

	setOfferName(form: FormGroup, offers: any[]) {
		//Initialise les noms des sous missionaire
		let noticeType: string;
		offers.sort((a, b) => a.id.localeCompare(b.id));
		if (form?.value) {
			noticeType = Object.keys(form?.value)[0];
		}
		if (noticeType) {
			let offersName: string[] = [];
			let offerFromFormUsed: boolean = false;
			for (let i = 0; i < offers?.length; i++) {
				if (offers[i]?.id != form?.get(noticeType)['controls']?.ublextensions?.controls.ublextension?.controls[0]?.controls.extensioncontent?.controls.eformsextension?.controls.noticeresult?.controls.lottender?.controls[0]?.value.id.val || this.canNavigateInStepperService.eformCreatingChange) {
					offersName.push(offers[i]?.name);
				} else {
					offerFromFormUsed = true;
					if ((form?.get(noticeType)['controls']?.ublextensions?.controls.ublextension?.controls[0]?.controls.extensioncontent?.controls.eformsextension?.controls.noticeresult?.controls.lottender?.controls[0]?.tenderreference?.controls[0]?.value.id.val === null || form?.get(noticeType)['controls']?.ublextensions?.controls.ublextension?.controls[0]?.controls.extensioncontent?.controls.eformsextension?.controls.noticeresult?.controls.lottender?.controls[0]?.tenderreference?.controls[0]?.value.id.val === undefined) && offers[i]?.name) {
						offersName.push(offers[i]?.name);
					} else {
						offersName.push(form?.get(noticeType)['controls']?.ublextensions?.controls.ublextension?.controls[0]?.controls.extensioncontent?.controls.eformsextension?.controls.noticeresult?.controls.lottender?.controls[0]?.tenderreference?.controls[0]?.value.id.val);
					}
				}
			}
			if (!offerFromFormUsed && !this.canNavigateInStepperService.eformCreatingChange) {
				offersName.push(form?.get(noticeType)['controls']?.ublextensions?.controls.ublextension?.controls[0]?.controls.extensioncontent?.controls.eformsextension?.controls.noticeresult?.controls.lottender?.controls[0]?.tenderreference?.controls[0]?.value.id.val);
			}
			this.offerName.next(offersName);
		} else {
			let offersName: string[] = [];
			for (let i = 0; i < offers?.length; i++) {
				offersName.push(offers[i]?.name);
			}
			this.offerName.next(offersName);
		}
	}

	getOfferName(): BehaviorSubject<string[]> {
		return this.offerName;
	}

	setLotName(form: FormGroup, lots: any[]) {
		//Initialise les noms des lots dans le stepper
		let noticeType: string;
		lots.sort((a, b) => a.id.localeCompare(b.id));
		if (form?.value) {
			noticeType = Object.keys(form?.value)[0];
		}
		if (noticeType) {
			let lotsName: string[] = [];
			let lotFromFormUsed: boolean = false;
			for (let i = 0; i < lots?.length; i++) {
				if (lots[i]?.id != form?.get(noticeType)['controls']?.procurementprojectlot?.controls[0]?.controls.id.value.val || this.canNavigateInStepperService.eformCreatingChange) {
					lotsName.push(lots[i]?.name);
				} else {
					lotFromFormUsed = true;
					if (form?.get(noticeType)['controls']?.procurementprojectlot?.controls[0]?.controls.procurementproject.value.name[0].val === null && lots[i]?.name) {
						lotsName.push(lots[i]?.name);
					} else {
						lotsName.push(form?.get(noticeType)['controls']?.procurementprojectlot?.controls[0]?.controls.procurementproject.value.name[0].val);
					}
				}
			}
			if (!lotFromFormUsed && !this.canNavigateInStepperService.eformCreatingChange) {
				lotsName.push(form?.get(noticeType)['controls']?.procurementprojectlot?.controls[0]?.controls.procurementproject.value.name[0].val);
			}
			this.lotName.next(lotsName);
		} else {
			let lotsName: string[] = [];
			for (let i = 0; i < lots?.length; i++) {
				lotsName.push(lots[i]?.name);
			}
			this.lotName.next(lotsName);
		}
	}

	getLotName(): BehaviorSubject<string[]> {
		return this.lotName;
	}
}
